// based on 2.0.0
import TouchFeedback from './src/TouchFeedback';
export default TouchFeedback;
